module.exports = __webpack_public_path__ + "media/images/covid/icons/vent-240bf13f3f91ec5c194557d5ba0f3142.svg";